<div class="flex flex-col w-full h-dvh min-h-0 min-w-0">
    <div class="h-1.5 sm:h-2"
        [ngStyle]="{
            'background-color': settingTheme?.menuBackgroundColour
        }">
    </div>
    <div class="flex items-center justify-between w-full h-12 min-w-0 px-2 bg-white shadow z-49 shrink-0 sm:pl-5 sm:pr-7 sm:h-15">
        <a [routerLink]="['/']" class="flex items-center flex-shrink-0 w-32 h-8 sm:h-10">
            @if (settingTheme) {
                <img class="object-contain object-left max-w-full max-h-8 sm:max-h-10" [src]="settingTheme.logo">
            }
        </a>
        <div class="flex items-center gap-1">
            <fuse-horizontal-navigation [name]="'mainNavigation'" [navigation]="navigation.navigationByRole"/>
            <outstanding-actions></outstanding-actions>
            <user></user>
        </div>
    </div>
    <div class="flex flex-col flex-1 min-w-0 min-h-0 w-full overflow-x-hidden overflow-y-auto">
        <!-- *ngIf="true" hack is required here for router-outlet to work correctly.
             Otherwise, layout changes won't be registered and the view won't be updated! -->
        @if (true) {
            <router-outlet></router-outlet>
        }
    </div>
</div>
